module.exports = __webpack_public_path__ + "img/6.79ab190a.jpg";